// import React from 'react';
// import { cn } from '../../utils/tailwind';

// interface ModalProps {
//   isOpen: boolean;
//   toggleModal: () => void;
//   children: React.ReactNode;
//   className?: string;
//   footer?: React.ReactNode;
//   width?: string; // Optional width prop (e.g., "w-1/2", "w-full", "max-w-md")
// }

// const Modal: React.FC<ModalProps> = ({
//   isOpen,
//   toggleModal,
//   children,
//   className,
//   footer,
//   width = 'w-[90%]', // Default width is 90%, but can be overridden
// }) => {
//   if (!isOpen) return null;

//   const handleOverlayClick = (e: React.MouseEvent) => {
//     e.stopPropagation(); // Prevent click event from propagating
//   };

//   return (
//     <div className="fixed inset-0 flex items-center justify-center z-50">
//       <div
//         className="fixed inset-0 bg-black opacity-50 pr-8"
//         onClick={handleOverlayClick}
//       ></div>
//       <div
//         className={cn(
//           'bg-white rounded-xl overflow-hidden shadow-xl transform transition-all max-h-[90vh] flex flex-col',
//           width, // Use the dynamic width passed via props
//           className,
//         )}
//       >
//         <div className="p-6 relative overflow-y-auto">
//             {showCloseButton && (
//             <button
//               className="fixed top-4 right-6 text-black"
//               onClick={toggleModal}
//             >
//               <span className="text-2xl">&times;</span>
//             </button>
//             )}
//           <div>{children}</div>
//         </div>
//         <div className="sticky bottom-0 bg-white px-6 py-2 flex-shrink-0">
//           {footer}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Modal;


import React from 'react';
import { cn } from '../../utils/tailwind';

interface ModalProps {
  isOpen: boolean;
  toggleModal?: () => void;
  children: React.ReactNode;
  className?: string;
  footer?: React.ReactNode;
  width?: string; // Optional width prop (e.g., "w-1/2", "w-full", "max-w-md")
  showCloseButton?: boolean; // Optional close button, default true
}

const Modal: React.FC<ModalProps> = ({
  isOpen,
  toggleModal,
  children,
  className,
  footer,
  width = 'w-[90%]', // Default width is 90%, but can be overridden
  showCloseButton = true, // Default to true
}) => {
  if (!isOpen) return null;

  const handleOverlayClick = (e: React.MouseEvent) => {
    e.stopPropagation(); // Prevent click event from propagating
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      <div
        className="fixed inset-0 bg-black opacity-50 pr-8"
        onClick={handleOverlayClick}
      ></div>
      <div
        className={cn(
          'bg-white rounded-xl overflow-hidden shadow-xl transform transition-all max-h-[90vh] flex flex-col',
          width, // Use the dynamic width passed via props
          className,
        )}
      >
        <div className="p-6 relative overflow-y-auto">
          {showCloseButton && (
            <button
              className="fixed top-4 right-6 text-black"
              onClick={toggleModal}
            >
              <span className="text-2xl">&times;</span>
            </button>
          )}
          <div>{children}</div>
        </div>
        <div className="sticky bottom-0 bg-white px-6 py-2 flex-shrink-0">
          {footer}
        </div>
      </div>
    </div>
  );
};

export default Modal;

